var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6689 43.3525L21.6689 32.7643",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.332 43.3525L38.332 32.7643",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.1172H60H52.3333C50.4477 15.1172 49.5049 15.1172 48.9191 15.703C48.3333 16.2888 48.3333 17.2316 48.3333 19.1172V56.9995C48.3333 58.8852 48.3333 59.828 47.7475 60.4138C47.1618 60.9995 46.2189 60.9995 44.3333 60.9995H15.6667C13.781 60.9995 12.8382 60.9995 12.2525 60.4138C11.6667 59.828 11.6667 58.8852 11.6667 56.9995V19.1172C11.6667 17.2316 11.6667 16.2888 11.0809 15.703C10.4951 15.1172 9.55228 15.1172 7.66667 15.1172H0Z",
    fill: "currentColor",
    fillOpacity: 0.05,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6654 4.53026C21.6654 4.53026 23.332 1 29.9987 1C36.6654 1 38.332 4.52941 38.332 4.52941",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0022812f2091fa9fb41665ed6a20f4da.svg";
export { ForwardRef as ReactComponent };